// React.
import { useMemo } from 'react';
import PropTypes from "prop-types";
import Highlight from "react-highlight";
import { Link } from "react-router-dom";

// Components.
import { formatSqlStatement } from "../../../helpers/utils";

function StatementToolTip(props: { cell: any, link?: string, onClick?: () => void, id: string, instanceType: string, position: number }) {

	const { cell, link, onClick, id, instanceType } = props;
	const limit: number = 999;
	const showFull: boolean = cell.row.values.sqltext.length <= limit;

    const text: string = useMemo (() =>
	{
		let text: string = formatSqlStatement (cell.row.values.sqltext,
			instanceType);

		if (text.length > limit) {
			text = text.substring (0, limit) + '\n...';
		}

		return text;
	}, [ cell.row.values.sqltext, instanceType ]);

    return <div id={id} data-testid='tooltip-wrapper' className="tooltip-wrapper"
				style={{ left: props.position }}>
        <div className="tooltip-content text-start">
            <Highlight className={`sql ${showFull ? "" : "preview"} text-start`}>
                {text}
            </Highlight>
            {!showFull && (onClick ? (
                <span className='tooltip-link text-start d-block' style={{ cursor: 'pointer' }} onClick={onClick}>See full statement</span>
            ) : (
                <Link className='tooltip-link text-start d-block' to={link!}>See full statement</Link>
            ))}
        </div>
    </div>
}

StatementToolTip.propTypes = {
    cell: PropTypes.object.isRequired,
};

export default StatementToolTip;
